export var dateNow=function(){return Math.floor(Date.now()/1e3)*1e3};
//# sourceMappingURL=dateNow.js.map